var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCollapse(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 4,
    viewBox: "0 0 7 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.78313 3.77082L0.218667 1.06373C-0.0799925 0.815004 -0.0715309 0.38726 0.236776 0.148292C0.498465 -0.0545418 0.887191 -0.0486536 1.14117 0.16199L3.5 2.68977L5.85883 0.16199C6.11281 -0.048654 6.50154 -0.0545416 6.76322 0.148292C7.07153 0.38726 7.07999 0.815004 6.78133 1.06373L4.21687 3.77082C4.21687 3.77082 3.9237 4 3.5 4C3.0763 4 2.78313 3.77082 2.78313 3.77082Z",
    fill: "#626262"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.78313 3.77082L0.218667 1.06373C-0.0799925 0.815004 -0.0715309 0.38726 0.236776 0.148292C0.498465 -0.0545418 0.887191 -0.0486536 1.14117 0.16199L3.5 2.68977L5.85883 0.16199C6.11281 -0.048654 6.50154 -0.0545416 6.76322 0.148292C7.07153 0.38726 7.07999 0.815004 6.78133 1.06373L4.21687 3.77082C4.21687 3.77082 3.9237 4 3.5 4C3.0763 4 2.78313 3.77082 2.78313 3.77082Z",
    fill: "#69707D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapse);
export default __webpack_public_path__ + "static/media/collapse.6e6802aab65e7b2240086290407ed4e5.svg";
export { ForwardRef as ReactComponent };